
<div>
  <VueFileAgent
    ref="fileAgent"
    :multiple="true"
    :deletable="true"
    :meta="true"
    :accept="'video/*'"
    :maxSize="maxSize"
    :maxFiles="1"
    :helpText="selectText"
    :readonly="isReadOnly"
    :errorText="{
      type:errorMessage,
      size: errorSize,
    }"
    :thumbnailSize="120"
    :theme="'list'"
    v-model="fileRecords"
    @select="filesSelected($event)"
    @beforedelete="onBeforeDelete($event)"
    @delete="onDelete($event)"
  ></VueFileAgent>
  <k-progress type="line" :percent="percentCnt"></k-progress>
</div>
